<template>
  <span
    class="rounded-xl relative border whitespace-nowrap duration-150"
    :class="[!adding ? 'border-dashed' : 'shadow-lg', error && '!border-red-500']"
    
    v-click-outside="hideAdder"
  >
    <div v-if="!adding" key="not-ading" class="duration-100 text-gray-400 rounded-xl space-x-2 flex items-center border-gray-300 p-1 cursor-pointer hover:bg-gray-50 px-4 inline-block" @click.stop="adding = true">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd" />
      </svg>
    
      <span class="-translate-y-[1px]">Add color</span>
    </div>
    <div v-else class="adding duration-100 rounded-xl" key="adding">
      <div>
        <input v-model="id" class="p-2 pr-0 w-32 rounded-tl-xl text-sm outline-none focus:ring-2 focus:ring-pink-600" id="input-id" placeholder='CSS class...'>
        <input v-model="label" class="p-2 pr-0 w-32 border-l border-gray-200 text-sm outline-none focus:ring-2 focus:ring-pink-600" placeholder='Color label...'>
        <button class="text-sm border-l border-gray-200 p-2 rounded-tr-xl text-blue-600 hover:bg-gray-50 duration-150" @click="save">
          Save
        </button>
      </div>
      <div class="border-t p-2 border-gray-200 text-gray-600 outline-none focus:ring-2 focus:ring-pink-600">
        CSS class result: <span :class="!isValidClassName && '!text-red-700'">{{ id }}</span>
        <br v-if="error">
        <span class="text-red-600">{{ error }}</span>
      </div>
    </div>
  </span>
</template>

<script>

export default {
  data() {
    return {
      id: "",
      label: "",
      error: null,

      adding: false,
    }
  },
  methods: {
    save() {
      if (!this.id || !this.label) return this.error = "You must provide an id and a label."
      if (!this.isValidClassName) return this.error = "Class name invalid."
      this.$emit("save", {id: this.id, label: this.label})
      this.adding = false
    },
    hideAdder() {
      this.adding = false
    },
  },
  computed: {
    isValidClassName() {
      return this.id && this.id.indexOf(' ') <= 0 && /-?(?:[_a-z]|[\200-\377]|\\[0-9a-f]{1,6}(\r\n|[ \t\r\n\f])?|\\[^\r\n\f0-9a-f])(?:[_a-z0-9-]|[\200-\377]|\\[0-9a-f]{1,6}(\r\n|[ \t\r\n\f])?|\\[^\r\n\f0-9a-f])*/.test(this.id)
    },
  },
  watch: {
    id() {
      this.error = null
    },
    label() {
      this.error = null      
    },
    adding(val) {
      this.id = ""
      this.label = ""
    },
  },
}

</script>
